import {
  fetchBanners,
  fetchMarketById,
  fetchPage,
  fetchPageLinks,
  localeToMarketCode,
  PageProps,
} from '@instabox/consumer-web-shared'
import { Stack } from '@instabox/consumer-web-ui'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'

import PageContent from '../components/PageContent'
import { dynamicPages } from '../lib/dynamicPages'

export interface DynamicPageProps extends PageProps {
  slug?: string
}

const DynamicPage: NextPage<DynamicPageProps> = ({ content, slug }) => {
  return (
    <Stack>
      <PageContent
        content={content}
        fields={[
          'cards',
          'images',
          'rich_texts',
          'subtitles',
          'texts_with_images',
          'titles',
          'heroes',
        ]}
        textsWithImagesLayout="fullBleed"
        slug={slug}
      />
    </Stack>
  )
}

export default DynamicPage

export const getStaticProps: GetStaticProps<DynamicPageProps> = async ({
  locale,
  params,
  ...context
}) => {
  const pageSlug = params.slug[params.slug.length - 1]
  const dynamicPage = dynamicPages.find(({ slug }) => slug === pageSlug)
  const {
    data: { marketById },
  } = await fetchMarketById(localeToMarketCode(locale))
  const page = await fetchPage(locale, pageSlug)
  const pageLinks = await fetchPageLinks(locale)
  const banners = await fetchBanners(locale, pageSlug)

  return {
    props: {
      market: marketById,
      pageLinks,
      slug: pageSlug,
      banners,
      ...page,
    },
    notFound: !page || dynamicPage?.skipGenerate?.({ locale, params, ...context }),
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
